<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<!-- <div
				class="top_logo"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-once="true"
				data-aos-offset="0"
			>
				<img src="@/assets/img/pc/logo.png" />
			</div> -->
			<div
				class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-once="true"
				data-aos-offset="0"
			>
				<img src="@/assets/img/pc/banner.png" />
			</div>
			<div class="main_main">
				<!-- <div
					class="about_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-once="true"
					data-aos-offset="0"
				>
					<div class="tit">关于我们</div>
					<div class="txt">
						赤壁保诺科技有限公司成立于2021年12月，位于湖北省赤壁市中伙光谷产业园，占地面积30亩，总投资1亿元，是一家集研发、生产、加工、销售和进出口的高新技术企业。
					</div>
					<div class="txt" style="padding-top: 12px;">
						公司拥有先进的电动注塑机全自动生产线，注塑机60台，NC膜生产线3套，洁净厂房6000㎡，体外诊断试剂日产能可达120万人份/天，依托先进的生产设备和完善的内部管理，始终保持产品质优畅销。
					</div>
				</div> -->
				
				<div
					class="product_box"
				>
					<div
						class="tit"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<div style="font-size: 30px;font-weight: bold;">Quality Plus&nbsp;&nbsp;i-Membrane</div>
						<div style="font-size: 24px;">For use in rapid diagnostic lateral flow tests</div>
						<div style="font-size: 24px;">Sealed in an easy-to-use card format</div>
					</div>
					<!-- <div
						class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						公司产品有金标卡壳、双耳提取管等塑料制品、硝酸纤维素膜、体外诊断试剂，例分子诊断、胶体金层析、荧光免疫、生物芯片、重组蛋白、mRNA疫苗等。
					</div> -->
					<div
						class="product_el"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<div class="img" style="float: left;">
							<img src="@/assets/img/pc/product_2.jpg" />
						</div>
						<div class="introduce">
							<div class="tit">Nitrocellulose Membrane (NC)</div>
							<div class="txt">
								Nitrocellulose membrane, also known as NC membrane, nitrocellulose membrane (NC) is a polymer used as the carrier of C/T lines in test strips, and it is also the place where immune reactions occur. NC membrane is the most important membrane material in immunochromatographic diagnostic technology. Different membrane pore sizes need to be selected according to sensitivity requirements, so as to determine different chromatographic speeds. The function of NC membrane is to pass the detection line T line and control line C line (Antibodies are typical) adsorption properties for specific target molecules fix them, while the detection conjugate of the sample is directed to the reaction area. To achieve this, the membrane must have a high protein adsorption capacity while also having certain voids and wettability to ensure capillary flow of aqueous samples.
							</div>
						</div>
					</div>
					
					<div
						class="product_el"
						data-aos="fade-left"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<div class="img" style="float: right;margin: 0 0 5px 30px;">
							<img src="@/assets/img/pc/product_1.png" />
						</div>
						<div class="introduce">
							<div class="tit">The Role & Advantages of NC Membrane</div>
							<div class="txt">
								Nitrocellulose membrane is the most widely used transfer medium for protein blotting, has strong binding ability to proteins, and is suitable for various color development methods, including isotopes, chemiluminescence, conventional color development, dyeing and fluorescence color development; Low background and high signal-to-noise ratio. The use of NC membranes is also very simple. For example, NC membranes are easy to seal and do not require particularly rigorous cleaning conditions. Proteins transferred to NC membranes can be stored stably for a long time under suitable conditions.
							</div>
						</div>
					</div>
					
					<div
						class="Membrane_introduce"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<div class="tit">i-Membrane</div>
						<div
							class="tit_el2"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-once="true"
							data-aos-offset="0"
						>
							i-Membrane is an industry leading partner to diagnostic manufacturers worldwide. We ensure a reliable supply of components and customizable services including membrane card development for IVD rapid testing applications. The preassembled membrane cards reduce preparation time and simplify your production and design process. The critical assembly of our membrane cards results in premier quality and performance for your IVD rapid test.
						</div>
						<div
							class="tit_el2"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-once="true"
							data-aos-offset="0"
						>
							i-Membrane offers high-quality consistency and performance for in-vitro diagnostic tests and kits manufactured according to the most critical specifications. Each membrane type has a specific particle mobility for a given particle size. The final product is a membrane consistency resulting in reliable performance of your rapid diagnostic test strip or device. i-Membrane offers optimized particle/bead size performance with desired speed and sensitivity of the chosen membrane.
						</div>
					</div>
					
					
					<div style="text-align: center;font-size: 28px;color: #333333;font-weight: bold;">Performance and Characteristics</div>
					<div
						class="show_icon"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<div class="left">
							<img src="@/assets/img/pc/icon_IM90.jpg" />
							<!-- <div>IM90 Air side view</div> -->
						</div>
						<div class="right">
							<img src="@/assets/img/pc/icon_IM135.jpg" />
							<!-- <div>IM135 Air side view</div> -->
						</div>
					</div>
					
					<!-- <div
						class="img_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<img src="https://i-membrane.com/images/about-en.png" />
					</div> -->
					
					<div
						class="table_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<div class="two_table">
							<div class="top_tit">
								<div class="normal">Speed</div>
								<div class="normal">Sensitivity</div>
								<div class="normal">Membrane Type</div>
								<div class="big">Description</div>
							</div>
							<div class="table_el">
								<div class="normal">Fast</div>
								<div class="normal">Modertate</div>
								<div class="normal">iM90&nbsp;&nbsp;iM95</div>
								<div class="big">For assays where sample and analyte are abundant <br />that require moderate speed and sensitivity</div>
							</div>
							<div class="table_el">
								<div class="normal">Medium</div>
								<div class="normal">High</div>
								<div class="normal">iM120&nbsp;&nbsp;iM125</div>
								<div class="big">For assays where sample and analyte are limited <br />or high sensitivity is needed</div>
							</div>
						</div>
					</div>
					
					<div
						class="about_main"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<div class="left">
							<div class="about_main_el">
								<div class="tit_tit">Consistent Thickness and Flow </div>
								<div class="txt_txt">i-Membrane’s consistent capillary flow time keeps the effective analyte concentration in your assay consistent. Therefore, you can accurately choose the more appropriate membrane for your application and develop assays with greater precision.</div>
							</div>
							<div class="about_main_el">
								<div class="tit_tit">Available Flow Rates For The Line Width <br />0.7 ～1.0 mm</div>
								<div class="txt_txt"> There is a direct correlation between the flow rate and sensitivity of the membrane. Fine-tune protein concentration as needed to improve quality consistency. Understanding these requirements for your application will enable you to select the appropriate membrane.</div>
							</div>
						</div>
						<div class="right">
							<div class="about_main_el">
								<div class="tit_tit">High protein Binding Affinity</div>
								<div class="txt_txt">Superior homogeneous microporous structure & smooth powder-free surface can maximize increase effective & microporous combination site and provide clear capture lines & definitive results.</div>
							</div>
							<div class="about_main_el">
								<div class="tit_tit">Quality Control</div>
								<div class="txt_txt">Specialized design & Customized production lines operated by Professional Technical team in accordance with ISO9001 to ensure intra and inter-batch consistency and high sensitivity during the products' validity period.</div>
							</div>
							<div class="about_main_el">
								<div class="tit_tit">Customer Focus & Satisfaction</div>
								<div class="txt_txt">i-Membrane team ensures that customer requirements and applicable regulatory requirements are determined and met.</div>
							</div>
						</div>
					</div>
					
					
					<div
						class="show_icon_img"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>
						<img src="@/assets/img/pc/icon_line.jpg" />
					</div>
					
					<div
						class="tit_el"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>In addition to our standard products, we also have the ability to <span class="col-b">customize</span> our membranes to improve assay performance in rapid diagnostic tests and applications. Contact your local account manager to discuss your assay optimization and product customization requirements.</div>
					<div
						class="tit_el"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>Also available are sample, absorbent and diagnostic pads needed for rapid diagnostic test strip applications and kits. These pad materials are standards in the industry and are available in multiple formats to suit your specific needs.</div>
					<div
						class="tit_el"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-once="true"
						data-aos-offset="0"
					>If you have any inquiries or questions, please feel free to contact us through <a style="color: #1890ff;" href="mailto:Info@i-Membrane.com">Info@i-Membrane.com</a>&nbsp;&nbsp;Thank you!</div>
				</div>
				
				<!-- <div
					class="contact_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-once="true"
					data-aos-offset="0"
				>
					<div class="tit">欢迎与我们联系</div>
					<div id="allmap" class="XSDFXPage"></div>
				</div> -->
			</div>
			<!-- <div class="footer">
				<div class="main">
					<div class="left">
						<div>公司名称：赤壁保诺科技有限公司</div> -->
						<!-- <div>联系我们：+86-18601366166</div> -->
						<!-- <div>邮箱：<a href="mailto:wentao@bonore.com">wentao@bonore.com</a></div>
						<div>公司地址：湖北省赤壁市中伙光谷产业园</div>
					</div>
				</div>
			</div> -->
		</div>
		<!--页面开始-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";  //轮播图插件
// import "swiper/dist/css/swiper.css";  //轮播图插件
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
	components:{
		// swiper,
		// swiperSlide,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			langchecked: sessionStorage.getItem('lang'),  //默认语言
			swiperOptions: {  //荣誉资质轮播
				loop: true,
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: false
				},
				slidesPerView: 3,
				spaceBetween: 42,
				effect: 'coverflow',
				coverflowEffect: {
					slideShadows: false, // 页面阴影效果
					rotate: 0, // 旋转的角度
					stretch: 100, // 拉伸   图片间左右的间距和密集度，越大靠得越近
					depth: 300, // 深度   切换图片间上下的间距和密集度，值越大z轴距离越远，看起来越小。
					modifier: 0.8, // 修正值 该值越大前面的效果越明显
				},
				/* pagination: {
				  el: '.swiper-pagination', //获取元素
				  clickable: true, //可根据圆点切换
				}, */
			},
			imgurl: '',  //全局地址
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.$nextTick(() => {
			AMapLoader.load({
				key:"c7422fb1c71586f2ab0e00eeeda9ea3e",  // 申请好的Web端开发者Key，首次调用 load 时必填
				version:"1.4.15",  // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
				plugins:[''],  // 需要使用的的插件列表，如比例尺'AMap.Scale'等
			}).then((AMap)=>{
				that.map = new AMap.Map("allmap",{  //设置地图容器id
					viewMode:"3D",    //是否为3D地图模式
					zoom: 14,           //初始化地图级别
					center:[113.993462, 29.751371], //初始化地图中心点位置
					lang: 'cn',
				});
				//构建信息窗体中显示的内容
				var info = [];
				info.push('<div style="width: 300px;margin-top: 10px;font-size:16px;font-weight:500;color:#D07852">' + '赤壁保诺科技有限公司' +'</div>');
				info.push('<span style="font-size:13px;">'+'地址：'+'：' + '湖北省赤壁市中伙光谷产业园' +'</span>');
				info.push('<span style="font-size:13px;">' +'电话：'+'：' + '18601366166' +'</span>');
				that.infoWindow = new AMap.InfoWindow({
					content: info.join("<br/>")  //使用默认信息窗体框样式，显示信息内容
				});
				that.infoWindow.open(that.map, that.map.getCenter());
			}).catch(e=>{
				console.log(e);
			});
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		//
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.main_box{width: 100%;margin: 0 auto;}

.about_main{
	margin: 35px 0 25px 0;
	display: flex;
}
.about_main .left{
	flex: 1;
	margin-right: 10px;
}
.about_main .right{
	flex: 1;
	margin-left: 10px;
}
.about_main_el{
	padding-bottom: 15px;
}
.about_main_el .tit_tit{
	font-size: 18px;
	color: #333333;
	font-weight: bold;
}
.about_main_el .txt_txt{
	font-size: 14px;
}

.Membrane_introduce .tit{
	font-size: 28px;
	color: #000000;
	padding-bottom: 20px !important;
}

.col-b{
	font-weight: bold;
	color: #333333;
}

.tit_el{
	margin-top: 35px;
	font-size: 16px;
	color: #333333;
}
.tit_el2{
	margin-bottom: 35px;
	font-size: 16px;
	color: #333333;
}

.show_icon{
	display: flex;
	padding-bottom: 88px;
	text-align: center;
}
.show_icon img{
	width: 100%;
	border-radius: 8px;
}
.show_icon div{
	padding-top: 15px;
	font-size: 18px;
	color: #333333;
}
.show_icon .left{
	flex: 1;
	margin-right: 15px;
}
.show_icon .right{
	flex: 1;
	margin-left: 15px;
}
.show_icon_img{
	width: 100%;
	margin-bottom: 50px;
}
.show_icon_img img{
	width: 100%;
}

.table_box{
	width: 100%;
	border: 2px solid #333333;
	padding: 8px;
}
.table_box .two_table{
	width: 100%;
	border: 3px solid #333333;
}
.table_box .top_tit{
	display: flex;
	background-color: #00549C;
	color: #ffffff;
	font-size: 14px;
	padding: 15px 0;
}
.table_box .table_el{
	display: flex;
	align-items: center;
	border-top: 1px solid #333333;
	padding: 20px 0;
	color: #333333;
}
.table_box div.normal{
	width: 160px;
	text-align: center;
}
.table_box div.big{
	flex: 1;
	text-align: center;
}


.top_logo{
	padding: 10px 0 10px 25px;
	font-size: 32px;
	color: #000000;
	line-height: 1;
}
.top_logo img{
	width: 320px;
	height: auto;
}
.banner_box img{
	width: 100%;
	height: auto;
}
.main_box .main_main{
	width: 1200px;
	margin: 0 auto;
	padding: 0 100px 150px 100px;
}
.about_box{
	margin-top: 148px;
}
.about_box .tit{
	text-align: center;
	/* padding-bottom: 48px; */
	font-size: 28px;
	color: #000000;
	line-height: 1;
}
.about_box .txt{
	font-size: 16px;
	color: #000000;
}

.product_box{
	margin-top: 148px;
}
.product_box .tit{
	text-align: center;
	padding-bottom: 50px;
	font-size: 28px;
	color: #000000;
	line-height: 1;
	font-weight: bold;
}
.product_box .tit div{
	padding-bottom: 15px;
}
.product_box .txt{
	padding-bottom: 88px;
	font-size: 16px;
	color: #000000;
}
.product_el{
	/* display: flex; */
	/* margin-bottom: 32px; */
	overflow: hidden;
}
.product_el .img{
	margin: 0px 30px 10px 0;
}
.product_el .img img{
	width: 460px;
	height: 350px;
}
.product_el .introduce{
	/* padding-left: 65px; */
}
.product_el .introduce .tit{
	font-size: 22px;
	color: #000000;
	padding-top: 20px;
	padding-bottom: 32px;
	line-height: 1.5;
	font-weight: bold;
}
.product_el .introduce .txt{
	font-size: 16px;
	color: #000000;
	line-height: 1.8;
}
.product_box .img_box img{
	width: 100%;
	height: 300px;
}

.contact_box{
	margin-top: 148px;
	text-align: center;
}
.contact_box .tit{
	font-size: 28px;
	color: #000000;
	line-height: 1;
}
.contact_box .txt{
	color: #000000;
	font-size: 16px;
	padding-top: 8px;
}
/*地图区域*/
.contact_box .XSDFXPage{
	width: 100%;
	height: 600px;
	margin: 48px 0 108px 0;
}

.footer{
	width: 100%;
	padding: 40px 0;
	background-color: #E9E9E9;
}
.footer .main{
	width: 1000px;
	margin: 0 auto;
	padding: 0 100px;
}
.footer .main{
	display: flex;
}
.footer .main .left{
	flex: 1;
}
.footer .main .left div{
	font-size: 24px;
	padding: 5px 0;
	text-align: center;
}
.footer .main .left div a{
	color: #666666;
}
.footer .main .right{
	flex: 1;
	text-align: right;
}

/*loading*/
.loading{width:100%;height:100%;position:absolute;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}
</style>
